// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC3L3TNdT6MuLFn8038KzHAg6K2itppS9E",
  authDomain: "officialimages-523a5.firebaseapp.com",
  projectId: "officialimages-523a5",
  storageBucket: "gs://officialimages-523a5.firebasestorage.app",
  messagingSenderId: "790827246878",
  appId: "1:790827246878:web:24bdabc7d27d9ace83d50f",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
